import { assert } from 'superstruct';
import { mergeConfig, removeEmpty } from './mergeConfig';
import { defaultConfig } from './defaultConfig';
import { SwipeSDKConfig } from '../../shares/types/SwipeSDKConfigType';
import { LogiSDKConfigSchema } from '../../shares/model/config';
import { setMemoryCache } from '../../shares/lib/memory.store';
import { LogiSDKConfig } from '../../shares/model/config';
import logger from '../../shares/lib/logger';

export function setSdkConfig(config: LogiSDKConfig) {
  const sdkConfig = mergeConfig(defaultConfig, config) as LogiSDKConfig;

  assert(sdkConfig, LogiSDKConfigSchema);

  setMemoryCache('config', sdkConfig);
  logger.updateConfig();

  return sdkConfig;
}

export function convertSdkConfig(config: SwipeSDKConfig): LogiSDKConfig {
  return removeEmpty({
    tenantId: config.tenantId,
    otpConfig: config.gameOTPConfig as never,

    locale: config?.locale && {
      language: config?.locale?.language,
      translations: config?.locale?.errorMessages as never,
    },
    logging: config.logging,
    onEvent: config?.events?.subscribe as never,

    enableSwipeGames: config.enableSwipeGame,
    swipeGames: {
      playForFunMode: config.playForFunMode,
      iconPosition: config.iconPosition,
      styles: config.styles,
      gameListConfig: config.gameListConfig as never,
      gameLaunchConfig: config.gameLaunchConfig as never,
      urlCallbackFn: config.urlCallbackFn as never,
    },

    enableMiniGames: config.enableMiniGame,
    miniGames: config.miniGames as never,

    enableSimulate: config.enableSimulate,
    simulate: config.simulate,

    enableSimulateSpecials: config.enableSimulateSpecials,
    simulateSpecials: config.simulateSpecials,
  });
}
